import React from 'react';
import cx from 'classnames';
import withBreakpoints, { InjectedProps as WithBreakpointsProps } from 'lib/withBreakpoints';
import sanityImgUtil from 'utils/sanityImgUtil';
import sanityImgSrcSetUtil from 'utils/sanityImgSrcSetUtil';

import { Block, ParagraphWithButton, Image } from 'lib/cms/types';
import Language from 'constants/Language';
import PortableText from 'components/PortableText';
import { LineIcon } from 'components/icons';
import { Img } from 'components/base';
import Classes from 'constants/Classes';

type PassedProps = {
  introImage?: Image;
  subheading?: string;
  heading: Block[];
  briefParagraph?: ParagraphWithButton;
  className?: string;
};

type Props = PassedProps & WithBreakpointsProps;

const HeroImageModule: React.FC<Props> = ({
  introImage,
  subheading,
  heading,
  briefParagraph,
  mediaQuery,
  className,
}) => {
  const breakpointIsSmUp = mediaQuery.isSmallUp;

  return (
    <div className={cx(`${Classes.heroImageModule} col-12 mb3_75 md:mb5 flex`, className)}>
      <div className="HeroImageModule__inner-container col-12 flex flex-col md:flex-row">
        <div
          className={cx(
            'HeroImageModule__left-column bg-color-mulberry site-padding-x-left pr2 pb1_75 md:pb2_75 flex flex-col col-12 md:col-6 justify-between',
            {
              'radius-xs': breakpointIsSmUp,
            }
          )}
        >
          <span className="pb7_5 md:pb2">
            <span className="inline primary-sm color-lilac pr1_5 md:pr3_75">{subheading}</span>
            <h1
              className={cx(
                'HeroImageModule__heading vertical-align-middle color-chalk inline hyphens font-primary'
              )}
            >
              <PortableText blocks={heading} />
            </h1>
          </span>

          {briefParagraph?.paragraph && (
            <h2 className="flex items-center secondary-bold-sm color-chalk">
              <LineIcon className="HeroImageModule__line-icon mr_25" color="chalk" />
              <PortableText blocks={briefParagraph?.paragraph} />
            </h2>
          )}
        </div>

        {introImage?.src && (
          <div className="HeroImageModule__image-container h100 col-12 md:col-6 flex flex-col relative md:pb2_75">
            <Img
              className={cx('fit-cover h100 flex col-12', {
                'radius-xs': breakpointIsSmUp,
              })}
              src={sanityImgUtil(introImage, 800)}
              srcSet={sanityImgSrcSetUtil(introImage, 768, 512, 720, 960)}
              sizes="(min-width: 768px) 50vw, 100vw"
              alt={introImage.alt || Language.t('Global.fallbackAltLabel')}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default withBreakpoints<Props>(HeroImageModule);
